import Man from './radio-icons/man.svg'
import Woman from './radio-icons/woman.svg'

import Sitting from './radio-icons/sitting.svg'
import Active from './radio-icons/active.svg'
import HardJob from './radio-icons/hard-job.svg'
import Quiet from './radio-icons/quiet.svg'

import Broccoli from './radio-images/broccoli.png'
import Mushroom from './radio-images/mushroom.png'
import Peas from './radio-images/peas.png'
import Pepper from './radio-images/pepper.png'
import Potato from './radio-images/potato.png'
import Tomato from './radio-images/tomato.png'

import Avacado from './radio-images/avacado.png'
import Eggs from './radio-images/eggs.png'
import Yogurt from './radio-images/yogurt.png'
import CottageCheesee from './radio-images/cottage-cheesee.png'
import Chees from './radio-images/chees.png'
import Olives from './radio-images/olives.png'
import Noots from './radio-images/noots.png'
import Pistachios from './radio-images/pistachios.png'


export const componentsProps = {
    Sex: {
        additionalClasses: 'component-with-progress-bar',
        title: 'Gender',
        subtitle: 'Choose your gender',
        options: [
            {
                name: "sex",
                number: "A",
                id: "woman",
                key: "woman",
                label: "Woman",
                imgUrl: Woman
            },
            {
                name: "sex",
                number: "B",
                id: "man",
                key: "man",
                label: "Man",
                imgUrl: Man
            }
        ]
    },

    BodyType: {
        additionalClasses: 'component-with-progress-bar',
        title: 'What is your body shape?',
        subtitle: 'Choose from below',
        defaultSex: 'woman',
        options: [
            {
                label: "Rectangle",
                sex: 'woman',
                img: '3w',
            },
            {
                label: "Hourglass",
                sex: 'woman',
                img: '5w',
            },
            {
                label: "Spoon",
                sex: 'woman',
                img: '2w'
            },
            {
                label: "Ellipse",
                sex: 'woman',
                img: '1w',
            },
            {
                label: "Rectangle",
                sex: 'man',
                img: '3w',
            },
            {
                label: "Hourglass",
                sex: 'man',
                img: '5w',
            },
            {
                label: "Spoon",
                sex: 'man',
                img: '2w'
            },
            {
                label: "Ellipse",
                sex: 'man',
                img: '1w',
            },

        ]
    },

    Activity: {
        additionalClasses: 'component-with-progress-bar',
        title: 'What is your lifestyle?',
        subtitle: 'How active are you during the day?',
        options: [
            {
                name: "activity",
                number: "A",
                id: "actA",
                key: "actA",
                label: "Passive",
                description: "Desk job",
                imgUrl: Sitting
            },
            {
                name: "activity",
                number: "B",
                id: "actB",
                key: "actB",
                label: "Active",
                description: "Training a lot",
                imgUrl: Active
            },
            {
                name: "activity",
                number: "C",
                id: "actC",
                key: "actC",
                label: "Manual labor",
                description: "Walking a lot",
                imgUrl: HardJob
            },
            {
                name: "activity",
                number: "D",
                id: "actD",
                key: "actD",
                label: "Moderate",
                description: "Mostly at home",
                imgUrl: Quiet
            }
        ]
    },

    BadHabits: {
        additionalClasses: 'component-with-progress-bar',
        title: 'Do you have any bad habits?',
        subtitle: 'Choose one option',
        options: [
            {
                name: "BadHabits",
                id: "badHA",
                key: "badHA",
                label: "I don’t sleep enough"
            },
            {
                name: "BadHabits",
                id: "badHB",
                key: "badHB",
                label: "I eat too much sugar"
            },
            {
                name: "BadHabits",
                id: "badHC",
                key: "badHC",
                label: "I drink too much soda"
            },
            {
                name: "BadHabits",
                id: "badHD",
                key: "badHD",
                label: "I consume a lot of salty food"
            },
            {
                name: "BadHabits",
                id: "badHE",
                key: "badHE",
                label: "I eat a lot of fast food"
            },
            {
                name: "BadHabits",
                id: "badHF",
                key: "badHF",
                label: "Nothing from above",
                // radio: true,
                // mustBeSingle: true
            },
        ]
    },

    PhysicalActivity: {
        additionalClasses: 'component-with-progress-bar',
        title: 'How physically active are you?',
        subtitle: 'Choose one option',
        options: [
            {
                name: "PhysicalActivity",
                id: "PhysicalAA",
                key: "PhysicalAA",
                label: "Doing sports often"
            },
            {
                name: "PhysicalActivity",
                id: "PhysicalAB",
                key: "PhysicalAB",
                label: "Going to ghe gym 1, 2 times per week"
            },
            {
                name: "PhysicalActivity",
                id: "PhysicalAC",
                key: "PhysicalAC",
                label: "Going to ghe gym 3 times and more per week"
            },
            {
                name: "PhysicalActivity",
                id: "PhysicalAD",
                key: "PhysicalAD",
                label: "I don’t do sports"
            },

        ]
    },

    WellBeing: {
        additionalClasses: 'component-with-progress-bar',
        title: 'How do you feel during the day?',
        subtitle: 'Choose one option',
        options: [
            {
                name: "WellBeing",
                id: "WellBA",
                key: "WellBA",
                label: "I feel energized during the day"
            },
            {
                name: "WellBeing",
                id: "WellBB",
                key: "WellBB",
                label: "I feel tired in the morning"
            },
            {
                name: "WellBeing",
                id: "WellBC",
                key: "WellBC",
                label: "Feeling weak after lunch"
            }
        ]
    },

    HasDiscomfort: {
        additionalClasses: 'component-with-progress-bar',
        title: 'Do you have stomach discomfort during the day?',
        subtitle: 'Choose one option',
        options: [
            {
                name: "HasDiscomfort",
                id: "HasDA",
                key: "HasDA",
                label: "Yes"
            },
            {
                name: "HasDiscomfort",
                id: "HasDB",
                key: "HasDB",
                label: "No"
            },
        ]
    },

    SleepTime: {
        additionalClasses: 'component-with-progress-bar',
        title: 'How many hours on average do you sleep?',
        subtitle: 'Choose one option',
        options: [
            {
                name: "SleepTime",
                id: "SleepTA",
                key: "SleepTA",
                label: "Less than 5 hours"
            },
            {
                name: "SleepTime",
                id: "SleepTB",
                key: "SleepTB",
                label: "5 to 6 hours"
            },
            {
                name: "SleepTime",
                id: "SleepTC",
                key: "SleepTC",
                label: "7 to 8 hours"
            },
            {
                name: "SleepTime",
                id: "SleepTD",
                key: "SleepTD",
                label: "I sleep more than 8 hours"
            },
        ]
    },

    WaterDrink: {
        additionalClasses: 'component-with-progress-bar',
        title: 'How much water do you drink per day?',
        subtitle: 'Choose one option',
        options: [
            {
                name: "WaterDrink",
                id: "WaterDA",
                key: "WaterDA",
                label: "I don’t count"
            },
            {
                name: "WaterDrink",
                id: "WaterDB",
                key: "WaterDB",
                label: "Less than 1 liter per day"
            },
            {
                name: "WaterDrink",
                id: "WaterDC",
                key: "WaterDC",
                label: "About 1-2 liters"
            },
            {
                name: "WaterDrink",
                id: "WaterDD",
                key: "WaterDD",
                label: "More than 3 liters"
            },
        ]
    },

    CookTime: {
        additionalClasses: 'component-with-progress-bar',
        title: 'How much time do you have to prepare food?',
        subtitle: 'Choose one option',
        options: [
            {
                name: "CookTime",
                id: "CookTA",
                key: "CookTA",
                label: "Less than 30 minutes"
            },
            {
                name: "CookTime",
                id: "CookTB",
                key: "CookTB",
                label: "30-60 minutes"
            },
            {
                name: "CookTime",
                id: "CookTC",
                key: "CookTC",
                label: "More than an hour"
            },
        ]
    },
    ChooseVegetables: {
        additionalClasses: 'component-with-progress-bar',
        title: 'Choose vegetables that you like',
        subtitle: 'Choose one or more options',
        theme: 'big',
        options: [
            {
                name: "vegetables",
                number: "A",
                id: "vegA",
                key: "vegA",
                label: "Broccoli",
                imgUrl: Broccoli
            },
            {
                name: "vegetables",
                number: "B",
                id: "vegB",
                key: "vegB",
                label: "Potato",
                imgUrl: Potato
            },
            {
                name: "vegetables",
                number: "C",
                id: "vegC",
                key: "vegC",
                label: "Mushrooms",
                imgUrl: Mushroom
            },
            {
                name: "vegetables",
                number: "D",
                id: "vegD",
                key: "vegD",
                label: "Tomatoes",
                imgUrl: Tomato
            },
            {
                name: "vegetables",
                number: "E",
                id: "vegE",
                key: "vegE",
                label: "Peas",
                imgUrl: Peas
            },
            {
                name: "vegetables",
                number: "F",
                id: "vegF",
                key: "vegF",
                label: "Pepper",
                imgUrl: Pepper
            },
        ]
    },
    FavoriteProducts: {
        additionalClasses: 'component-with-progress-bar',
        title: 'What are your favourite protein foods?',
        subtitle: 'Choose one or more options',
        theme: 'big',
        options: [
            {
                name: "FavoriteProducts",
                number: "A",
                id: "FavA",
                key: "FavA",
                label: "Avocado",
                imgUrl: Avacado
            },
            {
                name: "FavoriteProducts",
                number: "B",
                id: "FavB",
                key: "FavB",
                label: "Eggs",
                imgUrl: Eggs
            },
            {
                name: "FavoriteProducts",
                number: "C",
                id: "FavC",
                key: "FavC",
                label: "Yogurt",
                imgUrl: Yogurt
            },
            {
                name: "FavoriteProducts",
                number: "D",
                id: "FavD",
                key: "FavD",
                label: "Cottage cheese",
                imgUrl: CottageCheesee
            },
            {
                name: "FavoriteProducts",
                number: "E",
                id: "FavE",
                key: "FavE",
                label: "Cheese",
                imgUrl: Chees
            },
            {
                name: "FavoriteProducts",
                number: "F",
                id: "FavF",
                key: "FavF",
                label: "Olives",
                imgUrl: Olives
            },
            {
                name: "FavoriteProducts",
                number: "G",
                id: "FavG",
                key: "FavG",
                label: "Nuts",
                imgUrl: Noots
            },
            {
                name: "FavoriteProducts",
                number: "I",
                id: "FavI",
                key: "FavI",
                label: "Pistachios",
                imgUrl: Pistachios
            },
        ]
    },
    Height: {
        additionalClasses: 'component-with-progress-bar',
        title: 'How tall are you?',
        subtitle: 'Don’t worry if you don’t know the height exactly. This data can be changed later.',
        leftPlaceholder: 'Height',
        rightPlaceholder: 'cm',
        inputName: 'heightCm',
        validator: (value) => {

            if (value > 250) {
                return 'it seems you entered the wrong height'
            }

            return ''
        }
    },

    Weight: {
        additionalClasses: 'component-with-progress-bar',
        title: 'What is your weight?',
        subtitle: 'Don’t worry if you don’t know the weight exactly. This data can be changed later.',
        leftPlaceholder: 'Weight',
        rightPlaceholder: 'kg',
        inputName: 'weightKg',
        validator: (value) => {


            if (value < 36) {
                return 'it seems you entered the wrong weight'
            }

            if (value > 220) {
                return 'it seems you entered the wrong weight'
            }

            return ''
        }
    },

    NeededWeight: {
        additionalClasses: 'component-with-progress-bar',
        title: 'How much would you like to weigh?',
        subtitle: 'This data can be changed later.',
        leftPlaceholder: 'Your goal',
        rightPlaceholder: 'kg',
        inputName: 'needWeightKg'
    },

    WeightChart: {
        additionalClasses: 'component-with-progress-bar',
        title: `Easy Fitness поможет вам составить индивидуальный комплекс <br> физических упражнений и сбалансировать питание`,
        subtitle: 'Благодаря распределению физических нагрузок уже через несколько дней вы почувствуете прилив сил и энергии.'
    },
    WhatHeard: {
        bubbleTitle: 'Как часто вы занимаетесь спортом?',
        bubbleSubtitle: false,
        options: [
            {
                name: "whatHeard",
                number: "A",
                id: "whathA",
                key: "whathA",
                label: "Не занимаюсь",
            },
            {
                name: "whatHeard",
                number: "B",
                id: "whathB",
                key: "whathB",
                label: "Занимаюсь 1 - 2 раза в неделю",
            },
            {
                name: "whatHeard",
                number: "C",
                id: "whathC",
                key: "whathC",
                label: "Занимаюсь 3 и более раз в неделю",
            },
        ]
    },
    EatAtDay: {
        bubbleTitle: 'Ежедневное питание',
        bubbleSubtitle: 'Сколько раз вы едите в день?',
        additionalClasses: 'component-with-progress-bar',
        options: [
            {
                name: "eatFrequency",
                number: "A",
                id: "eatfrA",
                key: "eatfrA",
                label: "1",
            },
            {
                name: "eatFrequency",
                number: "B",
                id: "eatfrB",
                key: "eatfrB",
                label: "2",
            },
            {
                name: "eatFrequency",
                number: "C",
                id: "eatfrC",
                key: "eatfrC",
                label: "3",
            },
            {
                name: "eatFrequency",
                number: "D",
                id: "eatfrD",
                key: "eatfrD",
                label: "4 и более",
            }
        ]
    },
    EatHighCarbohydrate: {
        bubbleTitle: 'Продукты с высоким содержанием углеводов',
        bubbleSubtitle: 'Как часто вы едите продукты с высоким содержанием углеводов, такие как хлеб, молочные продукты, макаронные изделия и т. д.?',
        additionalClasses: 'component-with-progress-bar',
        options: [
            {
                name: "eatHighCarbohydrate",
                number: "A",
                id: "eatfrA",
                key: "eatfrA",
                label: "Очень часто",
            },
            {
                name: "eatHighCarbohydrate",
                number: "B",
                id: "eatfrB",
                key: "eatfrB",
                label: "Иногда",
            },
            {
                name: "eatHighCarbohydrate",
                number: "C",
                id: "eatfrC",
                key: "eatfrC",
                label: "Редко",
            },
            {
                name: "eatHighCarbohydrate",
                number: "D",
                id: "eatfrD",
                key: "eatfrD",
                label: "Совсем нет",
            }
        ]
    },
    Diet: {
        bubbleTitle: 'Диеты',
        bubbleSubtitle: 'Соблюдаете ли вы какую либо диету сейчас?',
        additionalClasses: 'component-with-progress-bar check-box-row-wrapper',
        options: [
            {
                name: "product1",
                id: "diet1",
                key: "product1",
                label: "Нет",
                mustBeSingle: true
            },
            {
                name: "product2",
                id: "diet2",
                key: "product2",
                label: "Кето-диета",
            },
            {
                name: "product3",
                id: "diet3",
                key: "product3",
                label: "Без содержания лактозы",
            },
            {
                name: "product4",
                id: "diet4",
                key: "product4",
                label: "Без содержания глютена",
            },
            {
                name: "product5",
                id: "diet5",
                key: "product5",
                label: "Другая",
            }
        ]
    },
    SleepMode: {
        additionalClasses: 'component-with-progress-bar check-box-row-wrapper',
        bubbleTitle: 'Модели сна',
        bubbleSubtitle: 'Как бы вы описали, насколько хорошо вы спите? Выберите все, что применимо.',
        options: [
            {
                name: "product1",
                id: "product1",
                key: "product1",
                label: "Заснуть занимает много времени",
            },
            {
                name: "product2",
                id: "product2",
                key: "product2",
                label: "Я ложусь спать после 23:00",
            },
            {
                name: "product3",
                id: "product3",
                key: "product3",
                label: "Я сплю менее 7 часов",
                radio: true,
            },
            {
                name: "product4",
                id: "product4",
                key: "product4",
                label: "Я сплю более 10 часов",
                radio: true,
            },
            {
                name: "product5",
                id: "product5",
                key: "product5",
                label: "Я никогда не чувствую себя отдохнувшим",
            },
            {
                name: "product6",
                id: "product6",
                key: "product6",
                label: "Я получаю рекомендуемые 8 часов",
                radio: true,
            }
        ]
    },
    Age: {
        additionalClasses: 'component-with-progress-bar',
        bubbleTitle: 'Возраст',
        bubbleSubtitle: 'Сколько вам лет?',
        options: [
            {
                name: "age",
                number: "A",
                id: "i18-29",
                key: "ageA",
                label: "18-29",
            },
            {
                name: "age",
                number: "B",
                id: "i30-39",
                key: "ageB",
                label: "30-39",
            },
            {
                name: "age",
                number: "C",
                id: "i40-49",
                key: "ageC",
                label: "40-49",
            },
            {
                name: "age",
                number: "D",
                id: "i50-59",
                key: "ageD",
                label: "50-59",
            },
            {
                name: "age",
                number: "E",
                id: "i60-69",
                key: "ageE",
                label: "60-69",
            },
            {
                name: "age",
                number: "F",
                id: "i70+",
                key: "ageF",
                label: "70+",
            }
        ]
    },
    BodyParameters: {
        additionalClasses: 'component-with-progress-bar',
        bubbleTitle: 'Какой у вас рост и вес?',
        bubbleSubtitle: 'Рост и вес необходимы для определения безопасного коэффициента потери веса.'
    },

    ImportantEvent: {
        bubbleTitle: 'Скоро наступит важное событие, которое мотивирует вас заняться спортом?',
        bubbleSubtitle: 'Люди, у которых есть дополнительная мотивация, обычно с большей вероятностью достигнут своей цели.',
        options: [
            {
                name: "date",
                id: "dateA",
                key: "dateA",
                label: "Отпуск",
                number: "A",
                isDatepicker: false,
            },
            {
                name: "date",
                id: "dateB",
                key: "dateB",
                label: "Свадьба",
                number: "B",
                isDatepicker: false,
            },
            {
                name: "date",
                id: "dateC",
                key: "dateC",
                label: "Спортивные соревнования",
                number: "C",
                isDatepicker: false,
            },
            {
                name: "date",
                id: "dateD",
                key: "dateD",
                label: "Лето",
                number: "D",
                isDatepicker: false,
            },
            {
                name: "date",
                id: "dateE",
                key: "dateE",
                label: "Встреча выпускников",
                number: "E",
                isDatepicker: false,
            },
            {
                name: "date",
                id: "dateF",
                key: "dateF",
                label: "Семейная встреча",
                number: "F",
                isDatepicker: false,
            },
            {
                name: "date",
                id: "dateG",
                key: "dateG",
                label: "День рождения",
                number: "G",
                isDatepicker: false,
            },
            {
                name: "date",
                id: "dateH",
                key: "dateH",
                label: "Нет, мне не нужно худеть к конкретной дате",
                number: "H",
                isDatepicker: false,
                dontRememberEventName: true
            },
            {
                name: "date",
                id: "dateI",
                key: "dateI",
                label: "Другое событие",
                type: 'text',
                dontRememberEventName: true
            },
        ]
    },
    WhenBirthday: {
        bubbleTitle: 'Когда день рождения?',
        bubbleSubtitle: 'Нам нужно знать это, чтобы определить для вас оптимальный план действий по снижению веса. Мы не передаем ваши персональные данные третьим лицам.',
    },
    SlimmingChart: {
        withChart: true,
        title: 'Единственная программа для занятия спортом, которая вам когда-либо понадобится',
        titleDescription: false,
        textForEvent: "И сделайте свое событие '${event}' еще более особенным"
    },
    SlimmingChartRecount: {
        withChart: true,
        title: 'Основываясь на ваших ответах и личных целях, вы можете достичь веса своей цели',
        titleDescription: false,
        textForEvent: "И сделайте свое событие '${event}' еще более особенным",
        shouldSlideY: true
    },
    Lifestyle: {
        additionalClasses: 'component-with-progress-bar',
        bubbleTitle: 'Что из перечисленного лучше всего описывает ваш образ жизни?',
        bubbleSubtitle: '{whoSex} в возрасте {age} лет иногда трудно достичь желаемого веса и поддерживать здоровый обмен веществ. Наша индивидуальная программа поможет вам добраться до целевого веса {goalWeigh} и достичь ваших целей в области здоровья и благополучия, сохраняя направление на улучшение образа жизни.',
        options: [
            {
                label: "Я не соблюдаю диету и не веду активный образ жизни"
            },
            {
                label: "Я слежу за питанием и изредка занимаюсь спортом"
            },
            {
                label: "Я веду здоровый образ жизни и регулярно занимаюсь спортом"
            },
        ]
    },
    TrivialDinner: {
        additionalClasses: 'component-with-progress-bar',
        bubbleTitle: 'Что из перечисленного лучше всего описывает ваш типичный обед?',
        bubbleSubtitle: 'В возрасте {age} лет продукты, которые вы сочетаете в еде, могут оказать значительное влияние на способность вашего организма сжигать жир.',
        options: [
            {
                label: "Я обычно ем бутерброды и роллы"
            },
            {
                label: "Я обычно ем супы и салаты"
            },
            {
                label: "Я предпочитаю есть фастфуд"
            },
        ]
    },
    TrivialDay: {
        additionalClasses: 'component-with-progress-bar',
        bubbleTitle: 'Что из перечисленного лучше всего описывает то, как часто вы питаетесь?',
        bubbleSubtitle: 'Частота и регулярность питания, помимо того какие продукты вы едите, также влияет на ваш метаболизм.',
        options: [
            {
                label: "В основном я ем менее трех раз в день"
            },
            {
                label: "Я делаю как минимум три приема пищи в день плюс несколько перекусов в течении дня"
            },
            {
                label: "Когда как, иногда меньше трех приемов пищи, иногда больше"
            },
        ]
    },
    IsTrainHelpEmotionally: {
        bubbleTitle: 'Оцените Ваше отношение к следующему высказыванию',
        bubbleSubtitle: '«Тренировки — это один из способов, которыми я обычно справляюсь со своими эмоциями»'
    },
    IsScheduleNotRegular: {
        bubbleTitle: 'Оцените Ваше отношение к следующему высказыванию',
        bubbleSubtitle: '«После недели или двух здорового питания или физических упражнений я возвращаюсь к своей старой рутине»'
    },
    HasBadEnvironment: {
        bubbleTitle: 'Оцените Ваше отношение к следующему высказыванию',
        bubbleSubtitle: '«Люди вокруг меня часто затрудняют мне придерживаться более здоровых привычек»'
    },
    EatDuringWork: {
        bubbleTitle: 'Оцените Ваше отношение к следующему высказыванию',
        bubbleSubtitle: '«Многозадачность во время еды стала для меня привычной (например, еда во время работы или прокрутка по телефону)»'
    },
    EatWhenOverflow: {
        bubbleTitle: 'Оцените Ваше отношение к следующему высказыванию',
        bubbleSubtitle: 'Даже если я уже сыт, обычно, я доедаю все что есть на тарелке'
    },
    FeelLikeFailure: {
        bubbleTitle: 'Оцените Ваше отношение к следующему высказыванию',
        bubbleSubtitle: '«Мои нездоровые решения часто приводят меня к принятию более нездоровых решений. Я чувствую себя неудачником, потому что не могу вести более здоровый образ жизни»'
    },
    Disease: {
        bubbleTitle: 'Есть ли у вас какие-либо заболевания?',
        bubbleSubtitle: 'Пожалуйста, сообщите нам, если у вас есть какое-либо из следующих условий',
        additionalClasses: 'check-box-row-wrapper',
        options: [
            {
                name: "disease",
                number: "A",
                id: "diseaseA",
                key: "diseaseA",
                label: "Анорексия",
            },
            {
                name: "disease",
                number: "B",
                id: "diseaseB",
                key: "diseaseB",
                label: "Булимия",
            },
            {
                name: "disease",
                number: "C",
                id: "diseaseC",
                key: "diseaseC",
                label: "Диабет",
            },
            {
                name: "disease",
                number: "D",
                id: "diseaseD",
                key: "diseaseD",
                label: "Высокое кровяное давление",
            },
            {
                name: "disease",
                number: "E",
                id: "diseaseE",
                key: "diseaseE",
                label: "Высокий уровень холестерина",
            },
            {
                name: "disease",
                number: "F",
                id: "diseaseF",
                key: "diseaseF",
                label: "Вопросы психического здоровья",
            },
            {
                name: "disease",
                number: "G",
                id: "diseaseG",
                key: "diseaseG",
                label: "Другое",
            },
            {
                mustBeSingle: true,
                name: "disease",
                number: "R",
                id: "diseaseR",
                key: "diseaseR",
                label: "У меня нет никаких заболеваний"
            }
        ]
    },
    Pills: {
        bubbleTitle: 'Лекарства',
        bubbleSubtitle: 'Пожалуйста, сообщите нам, если у вас есть какое-либо из следующих условий',
        additionalClasses: 'check-box-row-wrapper',
        options: [
            {
                name: "pills",
                number: "A",
                id: "pillsA",
                key: "pillsA",
                label: "Витамины",
            },
            {
                name: "pills",
                number: "B",
                id: "pillsB",
                key: "pillsB",
                label: "Гормоны",
            },
            {
                name: "pills",
                number: "C",
                id: "pillsC",
                key: "pillsC",
                label: "Антибиотики",
            },
            {
                name: "pills",
                number: "D",
                id: "pillsD",
                key: "pillsD",
                label: "Другое",
            },
            {
                name: "pills",
                number: "E",
                id: "pillsE",
                key: "pillsE",
                label: "Я не принимаю никаких лекарств",
                mustBeSingle: true,
            }
        ]
    },
    Budget: {
        bubbleTitle: 'Бюджет',
        bubbleSubtitle: 'Сколько вы готовы тратить на похудение в год?',
        options: [
            {
                name: "budget",
                number: "A",
                id: "budgetA",
                key: "budgetA",
                label: "Менее 20 долларов",
            },
            {
                name: "budget",
                number: "B",
                id: "budgetB",
                key: "budgetB",
                label: "От 20 до 50 долларов",
            },
            {
                name: "budget",
                number: "C",
                id: "budgetC",
                key: "budgetC",
                label: "От 50 до 100 долларов",
            },
            {
                name: "budget",
                number: "D",
                id: "budgetD",
                key: "budgetD",
                label: "От 100 до 200 долларов",
            },
            {
                name: "budget",
                number: "E",
                id: "budgetE",
                key: "budgetE",
                label: "200 долларов и больше",
            },
        ]
    }
}
